import {
    AfterViewInit,
    ChangeDetectorRef, Component, OnInit
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";

@Component({
    selector: "aihub-privacy",
    templateUrl: "./privacy.component.html",
    styleUrls: ["./privacy.scss"],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class PrivacyPage implements OnInit, AfterViewInit {
    constructor(
        private readonly activatedroute: ActivatedRoute,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) { }

    content: any;
    isLoaded = false;

    scroll = (id: string): any => {
        const el = document.getElementById(id);
        el.scrollIntoView({ behavior: "smooth", block: "end" });
        return false;
    }

    ngOnInit(): void {
        this.changeDetectorRef.detectChanges();

        this.activatedroute.data
            .pipe(switchMap((data) => from(data.content$)))
            .subscribe((content) => {
                if (content) {
                    this.content = content;
                    this.isLoaded = true;
                }
            });
    }

    ngAfterViewInit(): any {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
}
